import { DefinitionList, Panel } from './Panel.jsx';
import { Tag, UnitPill } from './StatusPill.jsx';
import { formatRelative, formatTimestamp } from '../lib/format.js';

export default function SlotCard({ slotName, slot = {}, preview, isAdmin, onPromote }) {
  const canPromote = Boolean(
    isAdmin && preview?.version && preview.version !== slot.version,
  );

  return (
    <Panel
      title={slotName === 'live' ? 'Live' : 'Preview'}
      subtitle={slotName === 'live' ? 'Customer-facing production slot' : 'Review builds here before promotion'}
      className={`slot-card slot-card--${slotName}`}
      actions={
        slotName === 'live' && isAdmin ? (
          <button type="button" className="btn btn--primary" onClick={onPromote} disabled={!canPromote}>
            Promote preview
          </button>
        ) : null
      }
    >
      <div className="slot-card__state">
        <UnitPill unit={slot.unit} />
        <Tag mono>{slotName}</Tag>
      </div>
      <DefinitionList
        items={[
          {
            label: 'URL',
            value: slot.url ? (
              <a href={slot.url} target="_blank" rel="noreferrer" className="mono">
                {slot.url}
              </a>
            ) : null,
          },
          { label: 'Release', value: slot.version || 'Nothing deployed', mono: Boolean(slot.version) },
          { label: 'Port', value: slot.port, mono: true, hint: 'loopback only' },
          {
            label: 'Deployed',
            value: formatTimestamp(slot.deployedAt),
            mono: true,
            hint: slot.deployedAt ? formatRelative(slot.deployedAt) : null,
          },
        ]}
      />
    </Panel>
  );
}
